export const getCurrentContent = ({ ugc }) => {
    const { showOriginal, ugcMap } = ugc;

    return showOriginal ? ugcMap.original : ugcMap.translated;
};
